export default {
    address: 'メールアドレス',
    familyName: '姓',
    givenName: '名',
    info: {
        editingTeamNameNotAutomaticallyChange:
            'メンバーの名前を変更しても、これまで作成した書類にある名前はそのままになり、自動的に更新されません。',
        goToYourEmailSettings:
            'メールアドレスの設定は<0>メールアドレス設定画面</0>にて確認できます。',
        note: '注意：',
        noteThatEditing:
            'メンバー名の変更はこれまでの書類には反映されませんのでご了承ください。（書類作成時の状態が保持されます）',
    },
    sendingSignature: '差出人署名',
    submit: 'メンバー情報を保存',
};
